import NodeCache from "node-cache";
import { iRegionalSite } from "../models/apiModels/regionalSite";
import { logError, logInfo } from "./azureBlobLogger";

const culturesCacheTTL = process.env.CULTURES_CACHE ? Number(process.env.CULTURES_CACHE) : 60 * 60 * 24;
const culturesCache = new NodeCache({ stdTTL: culturesCacheTTL });

export {
    getCountryCode as GetCountryCode,
    clearCulturesCache as ClearCulturesCache,
    getLanguageCode as GetLanguageCode,
    getISOCultureCode as GetISOCultureCode,
    getSpecialISOCultureCode as GetSpecialISOCultureCode,
    getPayExIsoLanguage as GetPayExIsoLanguage
};

function getPayExIsoLanguage(language: string, country: string): string {
    let convertetLanguageCode = "";

    switch (language.toLowerCase()) {
        case "no":
        case "nb":
        case "nn":
            convertetLanguageCode = "nb";
            break;
        case "da":
        case "dk":
            convertetLanguageCode = "da";
            break;
        case "se":
            convertetLanguageCode = "sv";
        case "en":
            convertetLanguageCode = "en";
            break;
    }

    return `${convertetLanguageCode}-${country.toUpperCase()}`;	
}

async function clearCulturesCache(): Promise<boolean> {
    logInfo('Clearing cultures cache');
    try {
        culturesCache.flushAll();
        return true;
    }
    catch (error) {
        logError('Error clearing cultures cache:', error);
        return false;
    }
}

function getCountryCode(cultureString: string, defaultCode: string = "sv"): string {
    let countryCode = "";

    if (cultureString.includes("-") || cultureString.includes("_")) {
        let cultureParts = cultureString.split(/[-_]/);
        countryCode = cultureParts.length > 1 ? cultureParts[1] : cultureParts[0];
    } else if (cultureString.length === 2) {
        countryCode = cultureString;
    }

    switch (countryCode.toLowerCase()) {
        case "no":
        case "nb":
        case "nn":
            countryCode = "no";
            break;
        case "da":
        case "dk":
            countryCode = "dk";
            break;
        case "se":
            countryCode = "sv";
            break;
        default:
            countryCode = defaultCode;
            break;
    }

    return countryCode;
}

function getISOCultureCode(cultureString: string) {
    var cultureCode = "";

    if (cultureString.includes("-") || cultureString.includes("_")) {
        let cultureParts = cultureString.split(/[-_]/);
        cultureCode = cultureParts.length > 1 ? cultureParts[1] : cultureParts[0];
    } else if (cultureString.length === 2) {
        cultureCode = cultureString;
    }

    switch (cultureCode.toLowerCase()) {
        case "no":
        case "nb":
        case "nn":
            cultureCode = "no";
            break;
        case "da":
        case "dk":
            cultureCode = "da";
            break;
        case "se":
            cultureCode = "sv";
        case "en":
            cultureCode = "en";
            break;
    }

    return cultureCode;
}

function getSpecialISOCultureCode(cultureString: string){
    let cultureCode = getISOCultureCode(cultureString);

    if (cultureCode === "nb") {
        cultureCode = "no";
    }

    return cultureCode;
}

function getLanguageCode(cultureString: string): string {
    let languageCode = "";

    if (cultureString.includes("-") || cultureString.includes("_")) {
        let cultureParts = cultureString.split(/[-_]/);
        languageCode = cultureParts[0];
    } else if (cultureString.length === 2) {
        languageCode = cultureString;
    }

    switch (languageCode.toLowerCase()) {
        case "no":
        case "nb":
        case "nn":
            languageCode = "no";
            break;
        case "da":
            languageCode = "dk";
            break;
        case "se":
            languageCode = "sv";
            break;
    }

    return languageCode;
}

